import React from "react";
import { newContextComponents } from "@drizzle/react-components";
import { Accordion, Card, Button, ProgressBar, Table } from 'react-bootstrap';

import BalanceOf from './BalanceOf'
import Transfer from './Transfer'
import Approve from './Approve'
import ChangeTaxContractAddress from './ChangeTaxContractAddress'
import ChangeTaxRatio from './ChangeTaxRatio'
import MainTokenChangeAdmin from './MainTokenChangeAdmin'
import MoveBNBFromContract from './MoveBNBFromContract'
import MoveBNBFromTaxContract from './MoveBNBFromContract'
import MoveTokensFromMainContract from './MoveTokensFromMainContract'
import MoveTokensFromTaxContract from './MoveTokensFromTaxContract'
import PauseMainToken from './PauseMainToken'
import ExcludeFrom from './ExcludeFrom'
import IncludeIn from './IncludeIn'
import IsExcludedFrom from './IsExcludedFrom'

import { Web3StatusContext } from "../../../contexts/Web3StatusContext";

const { AccountData, ContractData, ContractForm } = newContextComponents;

class MainToken extends React.Component {
  static contextType = Web3StatusContext;
  
  componentDidMount() {
    
  }

  componentDidUpdate() {
    
  }

  // destructure drizzle and drizzleState from props
  render() {
    return (
        <div>
          <Table striped bordered hover>
            <tbody>
              <tr>
                <td>
                  <h4>Get Balance</h4>
                  <BalanceOf
                    drizzle={this.props.drizzle}
                    drizzleState={this.props.drizzleState}>
                  </BalanceOf>
                </td>
              </tr>
              <tr>
                <td>
                  <h4>Approve Token</h4>
                  <Approve
                    drizzle={this.props.drizzle}
                    drizzleState={this.props.drizzleState}>
                  </Approve>
                </td>
              </tr>
              <tr>
                <td>
                  <h4>Transfer</h4>
                  <Transfer
                    drizzle={this.props.drizzle}
                    drizzleState={this.props.drizzleState}>
                  </Transfer>
                </td>
              </tr>
              <tr>
                <td>
                  <h4>Change Tax Contract Address</h4>
                  <ChangeTaxContractAddress
                    drizzle={this.props.drizzle}
                    drizzleState={this.props.drizzleState}>
                  </ChangeTaxContractAddress>
                </td>
              </tr>
              <tr>
                <td>
                  <h4>Change Tax Ratio</h4>
                  <ChangeTaxRatio
                    drizzle={this.props.drizzle}
                    drizzleState={this.props.drizzleState}>
                  </ChangeTaxRatio>
                </td>
              </tr>
              <tr>
                <td>
                  <h4>Is Excluded from Tax</h4>
                  <IsExcludedFrom
                    drizzle={this.props.drizzle}
                    drizzleState={this.props.drizzleState}
                    methodName='isExcludedFromTax'>
                  </IsExcludedFrom>
                </td>
              </tr>
              <tr>
                <td>
                  <h4>Exclude From Tax</h4>
                  <ExcludeFrom
                    drizzle={this.props.drizzle}
                    drizzleState={this.props.drizzleState}
                    methodName='addExcludedFromTax'>
                  </ExcludeFrom>
                </td>
              </tr>
              <tr>
                <td>
                  <h4>Include in Tax</h4>
                  <IncludeIn
                    drizzle={this.props.drizzle}
                    drizzleState={this.props.drizzleState}
                    methodName='removeExcludedFromTax'>
                  </IncludeIn>
                </td>
              </tr>
              <tr>
                <td>
                  <h4>Is Excluded from Pause</h4>
                  <IsExcludedFrom
                    drizzle={this.props.drizzle}
                    drizzleState={this.props.drizzleState}
                    methodName='isExcludedFromPause'>
                  </IsExcludedFrom>
                </td>
              </tr>
              <tr>
                <td>
                  <h4>Exclude From Pause</h4>
                  <ExcludeFrom
                    drizzle={this.props.drizzle}
                    drizzleState={this.props.drizzleState}
                    methodName='addExcludedFromPause'>
                  </ExcludeFrom>
                </td>
              </tr>
              <tr>
                <td>
                  <h4>Include in Pause</h4>
                  <IncludeIn
                    drizzle={this.props.drizzle}
                    drizzleState={this.props.drizzleState}
                    methodName='removeExcludedFromPause'>
                  </IncludeIn>
                </td>
              </tr>
              <tr>
                <td>
                  <h4>Change Admin</h4>
                  <MainTokenChangeAdmin
                    drizzle={this.props.drizzle}
                    drizzleState={this.props.drizzleState}>
                  </MainTokenChangeAdmin>
                </td>
              </tr>
              <tr>
                <td>
                  <h4>Pause Main Token</h4>
                  <PauseMainToken
                    drizzle={this.props.drizzle}
                    drizzleState={this.props.drizzleState}>
                  </PauseMainToken>
                </td>
              </tr>
              <tr>
                <td>
                  <h4>Move Tokens from Main Contract</h4>
                  <MoveTokensFromMainContract
                    drizzle={this.props.drizzle}
                    drizzleState={this.props.drizzleState}>
                  </MoveTokensFromMainContract>
                </td>
              </tr>
              <tr>
                <td>
                  <h4>Move BNB from Main Contract</h4>
                  <MoveBNBFromContract
                    drizzle={this.props.drizzle}
                    drizzleState={this.props.drizzleState}>
                  </MoveBNBFromContract>
                </td>
              </tr>
              <tr>
                <td>
                  <h4>Move Tokens from Tax Contract</h4>
                  <MoveTokensFromTaxContract
                    drizzle={this.props.drizzle}
                    drizzleState={this.props.drizzleState}>
                  </MoveTokensFromTaxContract>
                </td>
              </tr>
              <tr>
                <td>
                  <h4>Move BNB from Tax Contract</h4>
                  <MoveBNBFromTaxContract
                    drizzle={this.props.drizzle}
                    drizzleState={this.props.drizzleState}>
                  </MoveBNBFromTaxContract>
                </td>
              </tr>
            </tbody>
          </Table>
        </div>
    );
  }
};

export default MainToken;